import MapView from '../components/MapView';

// Placeholder data - will be replaced with real API calls
const mockLocations = [
  { id: '1', user_name: 'Juan Pérez', latitude: 10.49, longitude: -66.88, address_text: 'Caracas, Venezuela', captured_at: '2024-03-15T10:30:00' },
  { id: '2', user_name: 'María García', latitude: 10.50, longitude: -66.90, address_text: 'Altamira, Caracas', captured_at: '2024-03-14T15:45:00' },
  { id: '3', user_name: 'Carlos López', latitude: 10.48, longitude: -66.87, address_text: 'Chacao, Miranda', captured_at: '2024-03-13T09:20:00' },
];

export default function MapPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Mapa de Ubicaciones</h1>

      <div className="bg-white rounded-lg shadow p-4">
        <p className="text-sm text-gray-500 mb-4">
          Ubicaciones de usuarios que han consentido compartir su ubicación para fines logísticos.
        </p>
        <div className="h-[600px] rounded-lg overflow-hidden">
          <MapView locations={mockLocations} />
        </div>
      </div>

      {/* Location list */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold">Ubicaciones Recientes</h2>
        </div>
        <div className="divide-y">
          {mockLocations.map((loc) => (
            <div key={loc.id} className="p-4 flex justify-between items-center hover:bg-gray-50">
              <div>
                <p className="font-medium">{loc.user_name}</p>
                <p className="text-sm text-gray-500">{loc.address_text || 'Sin dirección'}</p>
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-500">
                  {loc.latitude.toFixed(4)}, {loc.longitude.toFixed(4)}
                </p>
                <p className="text-xs text-gray-400">
                  {new Date(loc.captured_at).toLocaleDateString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}